import { IPermission } from '../interfaces/global';
import { createEditPermission, deletePermission } from '../services/services';
import { useCancelQueries } from './useQueryData.hook';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export const useMutationCreateEditPermission = () => {
  const { invalidateQueries } = useCancelQueries();
  const mutation = useMutation<void, AxiosError, any>(['createEditPermission'], createEditPermission, {
    onSuccess: () => {
      invalidateQueries('useQueryPermission');
    }
  });
  return mutation;
};

export const useMutationDeletePermission = () => {
  const { invalidateQueries } = useCancelQueries();
  const mutation = useMutation<void, AxiosError, any>(['deletePermission'], deletePermission, {
    onSuccess: () => {
      invalidateQueries('useQueryPermission');
    }
  });
  return mutation;
};
